import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowUpRight, LockKeyhole } from "lucide-react";
import { getSsoConfig, localSso } from "../lib/api";
import { homeFor } from "../lib/admin";
import { PRODUCT_IDENTITY } from "../lib/story";

export default function SsoBroker({ onLogin }) {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [config, setConfig] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getSsoConfig()
      .then(({ data }) => setConfig(data))
      .catch(() => setConfig({ enabled: false }));
  }, []);

  useEffect(() => {
    if (config?.mode === "oidc" && config?.oidc_start) {
      window.location.assign(config.oidc_start);
    }
  }, [config]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await localSso({ name, email: email.trim() });
      const ok = await onLogin();
      if (!ok) {
        setError("Signed in, but the session could not be verified.");
        return;
      }
      navigate(homeFor(data), { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "SSO sign-in failed");
    } finally {
      setLoading(false);
    }
  };

  if (config && !config.enabled) {
    return (
      <main className="login-screen login-screen-auth" data-testid="sso-page">
        <div className="login-panel">
          <h2>SSO is disabled</h2>
          <Link to="/login">Back to sign in</Link>
        </div>
      </main>
    );
  }

  return (
    <main className="login-screen login-screen-auth" data-testid="sso-page">
      <div className="login-grid" />
      <section className="login-hero">
        <div className="eyebrow"><span className="signal" /> NEXTPROMIND · YUG360-MIND</div>
        <h1>Continue with<br /><em>SSO.</em></h1>
        <p>{config?.provider || "Northstar identity broker"}. New SSO identities join NRG-01 and see existing Northstar data. Seeded password accounts cannot be taken over here.</p>
        <Link className="text-button" to="/login">Back to sign in</Link>
      </section>
      <form className="login-panel" onSubmit={submit}>
        <div className="brand-mark">YUG<span>360</span><small>— MIND</small></div>
        <p className="kicker">{PRODUCT_IDENTITY.toUpperCase()}</p>
        <h2>Identity broker</h2>
        <p className="muted">Local SSO for this POC. Set SSO_ISSUER and SSO_CLIENT_ID to use Entra / Okta / Cognito.</p>
        <label htmlFor="sso-name">Name
          <input id="sso-name" data-testid="sso-name-input" name="name" autoComplete="name" required value={name} onChange={(e) => setName(e.target.value)} />
        </label>
        <label htmlFor="sso-email">Work email
          <input id="sso-email" data-testid="sso-email-input" type="email" name="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <div className="login-actions">
          <button data-testid="sso-submit-button" className="primary-button full" type="submit" disabled={loading || config?.mode === "oidc"}>
            {loading ? "Signing in…" : "Continue with SSO"} <ArrowUpRight size={16} />
          </button>
        </div>
        {error && <div data-testid="sso-error" className="error-message">{error}</div>}
        <div className="login-footer"><LockKeyhole size={14} /> Session is still JWT httpOnly cookies</div>
      </form>
    </main>
  );
}
